import React, { useEffect, useState } from 'react'
import { CU102_respuestas_derivacion } from '../../utils/Datos'
import { fechaHumana } from "../../utils/Util";
import { DocumentosDerivacion } from './DocumentosDerivacion';

export const RespuestasDerivaciones = ({id_derivacion=null}) => {

    const [respuestas, setrespuestas] = useState(null)

    useEffect(() => {
        CU102_respuestas_derivacion(id_derivacion).then((respuesta)=>{
            console.log("respuestas",respuesta);
            if (respuesta.status) {
                if (respuesta.datos.length>0) {
                    setrespuestas(respuesta.datos);
                }
                
                console.log("resoluciones",respuesta.datos.length)
            }
        })
    }, [id_derivacion])


  return (
    <>
        {respuestas!=null && respuestas!=[] ? 
        <>
            {
            respuestas.map((respuesta)=>{
                return <div className="border-gray-300 border-dotted p-4 mb-5 mt-5">
                    <div className='row'>
                        <div className='col-md-4 mb-4'>
                            <label className="form-label">ID Respuesta</label>
                            <input className='form-control form-control-solid' value={respuesta.id_answer_derivation}></input>
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label className="form-label">ID Derivación</label>
                            <input className='form-control form-control-solid' value={respuesta.id_derivation}></input>
                        </div>
                        <div className='col-md-4 mb-4'>
                            <label className="form-label">Fecha creación</label>
                            <input className='form-control form-control-solid' value={fechaHumana(respuesta.date_dreation)}></input>
                        </div>
                       
                        <div className='col-md-12'>
                            <label className="form-label">Comentario de resolución</label>
                            <div className="form-control form-control-solid" dangerouslySetInnerHTML={{ __html:respuesta.comment_resolution}}></div>
                        </div>
                        <div className="mb-4 col-md-12">
                            <DocumentosDerivacion id_answer_derivation={respuesta.id_answer_derivation}></DocumentosDerivacion>
                        </div>
                    </div>    
                </div>
            })
            }
        </> : 
            <div
                className="alert alert-info alert-light-info"
                role="alert"
            >
                <strong><i className='fas fa-exclamation-triangle me-3'></i></strong> No se encontraron respuestas
            </div>
            
        }
    </>
  )
}
